<template>
  <div class="p-3">
    <fcc-editor v-model="titulo"></fcc-editor>

    <div class="mt-2">
      <fcc-button @click="restaurar" class="mr-2" size="sm" color="outline-secondary"
        >Restaurar Padrão</fcc-button
      >
      <fcc-button @click="alterar" size="sm" color="outline-primary"
        >Definir como novo Texto Padrão</fcc-button
      >
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import fccStore from '@/store'
export default {
  props: ['value'],
  data() {
    return {
      titulo: ''
    }
  },
  mounted() {
    this.restaurar()
  },
  methods: {
    restaurar() {
      this.visualizaTituloPadrao().then((texto) => {
        this.titulo = texto
      })
    },
    alterar() {
      this.callConfirm(
        'Definir um novo texto padrão para Título?',
        'Ao definir um novo texto padrão, esse texto poderá ser usado futuramente, inclusive por outras configurações de local de prova. O texto padrão anterior será excluído.'
      ).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          this.alteraTituloPadrao().then(() => {
            this.carregaTexto()
            this.callToast(this.mensagensUpdate.editado, 'success')
          })
        }
      })
    },
    alteraTituloPadrao() {
      return new Promise((resolve) => {
        const payload = {
          descricao: this.titulo,
          cdFuncionario: this.dadosUserSession.usuCdFuncionario
        }

        axios
          .put(
            fccStore.state.baseUrlLocalDeProva + `LocalExameMensagem/AlteraTituloPadrao`,
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resolve)
          .catch(this.setErrorSystem)
      })
    },
    visualizaTituloPadrao() {
      return new Promise((resolve) => {
        axios
          .get(
            fccStore.state.baseUrlLocalDeProva + `ApresentacaoClassificacao/VisualizaTituloPadrao`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            resolve(response.data)
          })
          .catch(this.setErrorSystem)
      })
    }
  },
  watch: {
    value() {
      this.titulo = this.value
    },
    titulo: {
      handler() {
        this.$emit('input', this.titulo)
      },
      immediate: true
    }
  }
}
</script>